// extracted by mini-css-extract-plugin
export default {"melodyVideo":"RN-z","isFullWidth":"SN-z","landingPageVideo":"TN-z","play":"UN-z","iframeVideo":"VN-z","playHidden":"WN-z","fullwidth":"XN-z"};